<template>
  <div class="_ipbookingform__wrapper--content">
    <div class="_content">
      <div class="">
        <h4>Shipper Details</h4>
        <p @click.prevent="addAddress('shipper', 'add')"
          v-if="
            (shipperList &&
              shipperList.length < 1 &&
              !this.form.shipper_name) ||
            (shipperList && shipperList.length < 1)
          "
          class="_addresstext"
        >
          <u style="cursor: pointer; font-weight: 700; line-height: 16.34px;" >Choose address</u>
          <span class="_addresstext__alert" v-if="missingDataAlert.includes('shipper')"
            >!</span
          >
          <span class="fontstyle__errormsg" v-if="missingDataAlert.includes('shipper')"
            >Please complete this section</span
          >
        </p>

        <!-- show if history is available -->
        <p
          @click.prevent="chooseAddress('shipper')"
          v-if="
            (shipperList &&
              shipperList.length > 0 &&
              !this.form.shipper_name) ||
            (shipperList && shipperList.length > 0)
          "
          class="_addresstext"
        >
          <u style="cursor: pointer; font-weight: 700; line-height: 16.34px;"
            :class="`${rfqData ? rfqData.service_head === 'AIR' ? 'global__color_purple' : rfqData.service_head === 'LAND' ? 'global__color_deepgreen' : 'global__color_blue' : 'global__color_blue'}`" >Choose another address</u>
          <span class="_addresstext__alert" v-if="missingDataAlert.includes('shipper')"
            >!</span
          >
          <span class="fontstyle__errormsg" v-if="missingDataAlert.includes('shipper')"
            >Please complete this section</span
          >
        </p>
      </div>
      <div
        class="col-md p-0"
      >
        <b>{{ form.shipper_name || "-" }}</b>
        <p>{{ form.shipper_comp || "-" }}</p>
        <p>{{ form.shipper_company_tax_id || "-" }}</p>
        <p>{{ form.shipper_email || "-" }}</p>
        <p>{{ form.shipper_phonecode || "-" }}{{ form.shipper_phone || "-" }}</p>
        <p>{{ form.shipper_address || "-" }}</p>
        <p>{{ form.shipper_zip_code || "-" }}</p>
      </div>
      <hr />

      <!-- end Shipper Details -->
      <h4>Consignee Details</h4>
      <div class="">
        <p
          @click.prevent="addAddress('consignee', 'add')"
          v-if="
            (consigneeList &&
              consigneeList.length < 1 &&
              !this.form.consignee_name) ||
            (consigneeList && consigneeList.length < 1)
          "
          class="_addresstext"
        >
          <u style="cursor: pointer; font-weight: 700; line-height: 16.34px;" >Choose address</u>
          <span class="_addresstext__alert" v-if="missingDataAlert.includes('consignee') || missingDataAlert.includes('consignee_phonecode')"
            >!</span
          >
          <span class="fontstyle__errormsg" v-if="missingDataAlert.includes('consignee')"
            >Please complete this section</span
          >
          <span class="fontstyle__errormsg" v-else-if="missingDataAlert.includes('consignee_phonecode')"
            >Phone Code is required</span
          >
        </p>

        <!-- show if history is available -->
        <p
          @click.prevent="chooseAddress('consignee')"
          v-if="
            (consigneeList &&
              consigneeList.length > 0 &&
              !this.form.consignee_name) ||
            (consigneeList && consigneeList.length > 0)
          "
          class="_addresstext"
        >
          <u style="cursor: pointer; font-weight: 700; line-height: 16.34px;"
            :class="`${rfqData ? rfqData.service_head === 'AIR' ? 'global__color_purple' : rfqData.service_head === 'LAND' ? 'global__color_deepgreen' : 'global__color_blue' : 'global__color_blue'}`" >Choose another address</u>
          <span class="_addresstext__alert" v-if="missingDataAlert.includes('consignee') || missingDataAlert.includes('consignee_phonecode')"
            >!</span
          >
          <span class="fontstyle__errormsg" v-if="missingDataAlert.includes('consignee')"
            >Please complete this section</span
          >
          <span class="fontstyle__errormsg" v-else-if="missingDataAlert.includes('consignee_phonecode')"
            >Phone Code is required</span
          >
        </p>
      </div>
      <div
        class="col-md p-0 mb-4"
      >
        <b>{{ form.consignee_name || "-" }}</b>
        <p>{{ form.consignee_comp || "-" }}</p>
        <p>{{ form.consignee_company_tax_id || "-" }}</p>
        <p>{{ form.consignee_email || "-" }}</p>
        <p>{{ form.consignee_phonecode }}{{ form.consignee_phone }}</p>
        <p>{{ form.consignee_address || "-" }}</p>
        <p>{{ form.consignee_zip_code || "-" }}</p>
        <!-- <p class="fontstyle__errormsg" v-if="errorBookingFrom">*Please input consignee email by clicking “Edit” button.</p> -->
      </div>
      <!-- Consignee Details -->
      <hr />
      <h4>Notify Party Details</h4>
      <b-form-checkbox
        id="checkbox-1"
        v-model="form.notifiy_party_same_consignee"
        class="mb-2"
        name="checkbox-1"
        :value="1"
        :unchecked-value="0"
        :disabled="disabled_notify_party_checkbox"
        @change="setBookingForm()"
      >
        *Notify party is the same with consignee details
      </b-form-checkbox>
      <div v-show="form.notifiy_party_same_consignee === 0" class="row mb-4">
        <div class="col-md">
          <b-form-group
            id="input-group-1"
            label="Notify Party PIC Name"
            label-for="input-1"
          >
            <b-form-input
              v-model="form.notifiy_party_name"
              v-validate="'required'"
              name="party_name"
              type="text"
              required
              placeholder="Insert Notify Party PIC Full Name"
              @change="setBookingForm()"
            ></b-form-input>
          </b-form-group>
          <div style="margin-bottom: 1rem">
            <label>Phone Number</label>
            <div class="phone__wrapper" style="margin-bottom: 0rem">
              <div class="col-4" style="padding: 0px;">
                <v-select
                  v-model="notifiy_party_phonecode"
                  :options="optionDialCode || []"
                  label="phonecode"
                  name='party_phone_code'
                  placeholder="Code"
                  class="phone__code"
                  :clearable="false"
                >
                <template slot="option" slot-scope="option">+{{ option.phonecode }}</template>
                <template slot="selected-option" slot-scope="option">+{{ option.phonecode }}</template>
                </v-select>
              </div>
              <b-form-group id="input-group-1" label-for="input-1" class="col-8" style="margin-bottom: 0px; padding: 0px;">
                <b-form-input
                  v-model="form.notifiy_party_phone"
                  v-validate="'required'"
                  name="party_phone"
                  type="number"
                  required
                  placeholder="Notify Party PIC Phone Number"
                  @change="setBookingForm()"
                ></b-form-input>
              </b-form-group>
            </div>
            <p v-if="missingDataAlert.includes('notify_phonecode')" class="fontstyle__errormsg"> Phone Number field is required </p>
          </div>
          <b-form-group id="input-group-1" label="Email" label-for="input-1">
            <b-form-input
              v-validate="'email'"
              v-model="form.notify_party_email"
              name="party_email"
              type="email"
              placeholder="Notify Party Email"
              @change="setBookingForm()"
            ></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-1" label="Postal Code" label-for="input-1">
            <b-form-input
              v-validate="'required'"
              v-model="form.notifiy_party_zip_code"
              name="party_zipcode"
              type="number"
              required
              placeholder="Notify Party Postal Code Number"
              @change="setBookingForm()"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md">
          <b-form-group
            id="input-group-1"
            label="Company Name"
            label-for="input-1"
          >
            <b-form-input
              v-model="form.notifiy_party_comp"
              v-validate="'required'"
              name="party_comp"
              type="text"
              required
              placeholder="Notify Party Company Name"
              @change="setBookingForm()"
            ></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-1" label-for="input-1">
            <div class="row m-0 justify-content-between align-items-end">
              <label>Company Tax ID</label>
              <small class="mb-2">*Optional</small>
            </div>
            <b-form-input
              name="party_taxid"
              type="text"
              v-model="form.notifiy_party_company_tax_id"
              placeholder="Notify Party Company Tax ID"
              @change="setBookingForm()"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-1"
            label="Address"
            label-for="input-1"
          >
            <b-form-textarea
              v-model="form.notifiy_party_address"
              name="party_address"
              required
              v-validate="'required'"
              placeholder="Notify Party Company Address"
              rows="3"
              max-rows="6"
              @change="setBookingForm()"
            ></b-form-textarea>
          </b-form-group>
        </div>
      </div>

      <hr v-if="form.notifiy_party_same_consignee === 0" />

      <h4>Shipper Notes</h4>
      <div class="col-md p-0">
        <b-form-group
          id="input-group-1"
          label-for="input-1"
          description="*Optional"
        >
          <b-form-textarea
            v-model="form.shipper_notes"
            name="shipper_notes"
            placeholder="e.g : 'cargo can't be stacked, cargo load into lower deck.'"
            rows="4"
            max-rows="6"
            @change="setBookingForm()"
          ></b-form-textarea>
        </b-form-group>
      </div>
      <hr />
      <template v-if="rfqData && rfqData.service_head !== 'LAND'">
        <h4 v-if="!mandatoryAlert" >Billing Address</h4>
        <h4 v-if="mandatoryAlert" style="color: #b73441">Billing Address</h4>
        <div v-if="this.billingAddressGlobal !== null">
          <div style="font-size: 12px; margin-bottom: 10px;">
            <p><b>Warehouse 1</b> </p>
          </div>
          
          <p style="font-style: 18px;"> 
            <b>{{this.billingAddressGlobal.companyName}}</b></p>
          <p>+{{this.billingAddressGlobal.phoneCode}}{{this.billingAddressGlobal.phoneNumber}}</p>
          <p>{{this.billingAddressGlobal.npwp}}</p>
          <div style="max-width: 270px; margin-bottom: 10px;">
            <p>{{this.billingAddressGlobal.address}}</p>
            <p>{{this.billingAddressGlobal.cityName}}, {{this.billingAddressGlobal.countryName}}, {{this.billingAddressGlobal.postCode}}</p>
            <!-- <p>{{this.billingAddressGlobal.districtName || '-'}}, {{this.billingAddressGlobal.subdistrictName || '-'}}, {{this.billingAddressGlobal.cityName || '-'}}</p>
            <p>{{this.billingAddressGlobal.provinceName || '-'}}, {{this.billingAddressGlobal.countryName || '-'}}, {{this.billingAddressGlobal.postCode || '-'}}</p> -->
          </div>
        </div>
        <div>
          <router-link  class="_addresstext" :to="{ name: 'BillingAddress'}">
            <u style="cursor: pointer; font-weight: 700; line-height: 16.34px;"
            :class="`${rfqData ? rfqData.service_head === 'AIR' ? 'global__color_purple' : 'global__color_blue' : 'global__color_blue'}`" >Choose another address</u>
          </router-link>
        </div>
        <div v-if="mandatoryAlert">
          <p style="color: #b73441">Mandatory! Please select your billing address</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'formBooking',
  props: {
    shipmentType: String,
    shipmentMethod: String,
    bookingData: Object,
    errorBookingFrom: Boolean,
    missingDataAlert: Array,
    mandatoryAlert: Boolean
  },
  data () {
    return {
      form: {
        shipper_name: '',
        shipper_comp: '',
        shipper_address: '',
        shipper_phone: '',
        shipper_phonecode: '',
        shipper_email: '',
        shipper_zip_code: '',
        shipper_company_tax_id: '',
        consignee_name: '',
        consignee_comp: '',
        consignee_address: '',
        consignee_phone: '',
        consignee_phonecode: '',
        consignee_zip_code: '',
        consignee_company_tax_id: '',
        notifiy_party_comp: '',
        notifiy_party_name: '',
        notifiy_party_address: '',
        notifiy_party_phonecode: null,
        notifiy_party_phone: '',
        notifiy_party_zip_code: '',
        notify_party_email: '',
        notifiy_party_company_tax_id: '',
        notifiy_party_same_consignee: 0,
        shipper_notes: '',
        consignee_email: ''
      },
      notifiy_party_phonecode: null,
      quote: {},
      query: {
        form: {}
      },
      idAddrShipperSelected: '',
      idAddrConsigneeSelected: '',
      payloadLog: {
        featureName: 'ACCEPT QUOTATION',
        featureStep: 1,
        stepName: 'BOOKING',
        featureProcess: {
          status: 'success',
          data: {}
        }
      },
      hoverEdit: false,
      mandatoryBillAddress: false,
      disabled_notify_party_checkbox: true,
      optionDialCode: []
    }
  },
  mounted () {
    this.getDataLocalStorage()
    this.inputFormField()
    localStorage.removeItem('bookingFormData')
    this.getMandatoryBill()
    this.checkDataBillingGlobal()
    this.getDialCode()
  },
  computed: {
    ...mapGetters({
      rfqData: 'rfq/item',
      // address temp
      addressData: 'address/dataAddressTemp',
      // book
      booked: 'book/items',
      isErrorBook: 'book/error',
      // address shipper list
      shipperList: 'address/shipperList',
      isLoadingShipperList: 'address/isLoadingShipperList',
      errorShipperList: 'address/errorShipperList',
      // address consignee list
      consigneeList: 'address/consigneeList',
      isLoadingConsigneeList: 'address/isLoadingConsigneeList',
      errorConsigneeList: 'address/errorConsigneeList',
      // profile
      profile: 'auth/profile',

      billingAddress: 'address/billingAddress',
      // global billing
      billingAddressGlobal: 'address/billingAddressGlobal',

      // phone code
      dialcode: 'auth/dialcode',
      isLoadingDialcode: 'auth/isLoadingDialcode'
    })
  },
  methods: {
    checkDataBillingGlobal () {
      if (this.billingAddressGlobal !== null) {
        this.mandatoryBillAddress = true
      } else {
        this.mandatoryBillAddress = false
      }
    },
    getMandatoryBill () {
      this.$emit('mandatoryBillAddress', this.mandatoryBillAddress)
    },
    getDataLocalStorage () {
      const data = JSON.parse(localStorage.getItem('bookingFormData'))
      if (data) {
        this.form = data
      }
    },
    async inputFormField () {
      await this.$store.dispatch('address/FETCH_ADDRESS_SHIPPER', 'shipper')
      await this.$store.dispatch('address/FETCH_ADDRESS_CONSIGNEE', 'consignee')
      
      const shipper =
        this.shipperList && this.shipperList.length !== 0
          ? this.shipperList[this.shipperList.length - 1]
          : {
            id: '',
            fullname: '',
            company_name: '',
            address: '',
            phone_number: '',
            phone_code: '',
            email: '',
            zip_code: '',
            company_tax_id: ''
          }

      const consignee =
        this.consigneeList && this.consigneeList.length !== 0
          ? this.consigneeList[this.consigneeList.length - 1]
          : {
            id: '',
            fullname: '',
            company_name: '',
            address: '',
            phone_number: '',
            phone_code: '',
            email: '',
            zip_code: '',
            company_tax_id: ''
          }
      // shipper data
      this.idAddrShipperSelected = shipper.id
      this.form.shipper_name = shipper.fullname
      this.form.shipper_comp = shipper.company_name
      this.form.shipper_address = shipper.address
      this.form.shipper_email = shipper.email
      this.form.shipper_phone = shipper.phone_number
      this.form.shipper_phonecode = shipper.phone_code
      this.form.shipper_zip_code = shipper.zip_code
      this.form.shipper_company_tax_id = shipper.company_tax_id

      // consignee data
      this.idAddrConsigneeSelected = consignee.id
      this.form.consignee_name = consignee.fullname
      this.form.consignee_comp = consignee.company_name
      this.form.consignee_address = consignee.address
      this.form.consignee_phone = consignee.phone_number
      this.form.consignee_phonecode = consignee.phone_code
      this.form.consignee_email = consignee.email
      this.form.consignee_zip_code = consignee.zip_code
      this.form.consignee_company_tax_id = consignee.company_tax_id
      
      this.checkboxDisabled()
      this.setDataLocalStorage()
    },
    setDataLocalStorage () {
      const data = JSON.stringify(this.form)
      localStorage.setItem('bookingFormData', data)
    },
    addAddress (type, method, idAddr) {
      // method edit / add new address
      this.$eventHub.$emit('dialog-form-address-add', { type, method, idAddr })
    },
    chooseAddress (type) {
      if (type === 'shipper') {
        this.$store.dispatch('address/FETCH_ADDRESS_SHIPPER', type)
      } else {
        this.$store.dispatch('address/FETCH_ADDRESS_CONSIGNEE', type)
      }
      this.$eventHub.$emit('dialog-form-address-choose', { type, selectedForm: this.form })
    },
    setBookingForm () {
      this.$emit('getBookingForm', this.form)
      this.setDataLocalStorage()
    },
    deleteAddress (id) {
      this.$eventHub.$emit('dialog-form-address-delete', id)
    },
    async getDialCode () {
      await this.$store.dispatch('auth/FETCH_DIAL_COUNTRY_CODE')
    },
    checkboxDisabled () {
      if (this.form.consignee_name) {
        this.form.notifiy_party_same_consignee = 1
        setTimeout(() => {
          this.disabled_notify_party_checkbox = false
        }, 100)
      } else {
        this.form.notifiy_party_same_consignee = 0
        setTimeout(() => {
          this.disabled_notify_party_checkbox = true
        }, 100)
      }
    }
  },
  watch: {
    booked (data) {
      if (data) {
        this.payloadLog.featureProcess.stats = 'success'
        this.payloadLog.featureProcess.data = data
        // insert log
        this.$store.dispatch('log/CREATE_LOG', this.payloadLog)
      }
    },
    isErrorBook (data) {
      if (data) {
        this.payloadLog.featureProcess.stats = 'failed'
        this.payloadLog.featureProcess.data = data
        // insert log
        this.$store.dispatch('log/CREATE_LOG', this.payloadLog)
      }
    },
    addressData (data) {
      if (data) {
        if (data.typeAddress === 'consignee') {
          // consignee data
          this.form.consignee_name = data.consignee_name
          this.form.consignee_comp = data.consignee_comp
          this.form.consignee_address = data.consignee_address
          this.form.consignee_phone = data.consignee_phone
          this.form.consignee_phonecode = data.consignee_phonecode
          this.form.consignee_zip_code = data.consignee_zip_code
          this.form.consignee_company_tax_id = data.consignee_company_tax_id
          this.form.consignee_email = data.consignee_email
          if (data.consignee_email) {
            this.$emit('checkErrorBookingForm', false)
          }
          this.idAddrConsigneeSelected = data.id
          if (this.form.notifiy_party_same_consignee === 1) {
            // notify party data
            this.form.notifiy_party_name = data.consignee_name
            this.form.notifiy_party_comp = data.consignee_comp
            this.form.notifiy_party_address = data.consignee_address
            this.form.notifiy_party_phone = data.consignee_phone
            this.form.notifiy_party_phonecode = data.consignee_phonecode
            this.form.notifiy_party_zip_code = data.consignee_zip_code
            this.form.notifiy_party_company_tax_id =
              data.consignee_company_tax_id
            this.form.notify_party_email = data.consignee_email
          }
        }
        if (data.typeAddress === 'shipper') {
          // shipper data
          this.idAddrShipperSelected = data.id
          this.form.shipper_name = data.shipper_name
          this.form.shipper_comp = data.shipper_comp
          this.form.shipper_address = data.shipper_address
          this.form.shipper_email = data.shipper_email
          this.form.shipper_phone = data.shipper_phone
          this.form.shipper_phonecode = data.shipper_phonecode
          this.form.shipper_zip_code = data.shipper_zip_code
          this.form.shipper_company_tax_id = data.shipper_company_tax_id
          if (data.shipper_email) {
            this.$emit('checkErrorBookingForm', false)
          }
        }
        this.setBookingForm()
        this.checkboxDisabled()
      }
    },
    idAddrConsigneeSelected (val) {
      if (val) {
        this.checkboxDisabled()
      }
    },
    dialcode (data) {
      if (data) {
        this.optionDialCode = data.data
      }
    },
    'form.notifiy_party_same_consignee' (val) {
      if (val === 1) {
        this.form.notifiy_party_name = this.form.consignee_name
        this.form.notifiy_party_comp = this.form.consignee_comp
        this.form.notifiy_party_address = this.form.consignee_address
        this.form.notify_party_email = this.form.consignee_email
        this.form.notifiy_party_phone = this.form.consignee_phone
        this.form.notifiy_party_phonecode = this.form.consignee_phonecode
        this.form.notifiy_party_zip_code = this.form.consignee_zip_code
        this.form.notifiy_party_company_tax_id = this.form.consignee_company_tax_id
      } else {
        this.form.notifiy_party_name = ''
        this.form.notifiy_party_comp = ''
        this.form.notifiy_party_address = ''
        this.form.notify_party_email = ''
        this.form.notifiy_party_phonecode = null
        this.notifiy_party_phonecode = null
        this.form.notifiy_party_phone = ''
        this.form.notifiy_party_zip_code = ''
        this.form.notifiy_party_company_tax_id = ''
      }
      this.setBookingForm()
    },
    notifiy_party_phonecode (val) {
      if (val) {
        this.form.notifiy_party_phonecode = `+${val.phonecode}`
        this.setBookingForm()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bookingForm/BookingForm.vue